import Bind from 'bind.js';

export default class Intro {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.addContent();
  }

  addContent() {
    let template = `
    <div class="intro_copy">
      <h1></h1>
      <p></p>
    </div>
    `

    this.parentElement.insertAdjacentHTML("afterbegin", template);

    this.editor = Bind(
      {
        title: this.data.get('title'),
        copy: this.data.get('copy')
      },
      {
        title: '.intro_copy h1',
        copy: '.intro_copy p'
      }
    );
  }

  reRender(data) {
    this.data = data;
    this.editor.title = data.get('title');
    this.editor.copy = data.get('copy');
  }
}



// WEBPACK FOOTER //
// ./src/renderers/Intro.js